import dayjs from "dayjs-es";
import { RouteNames } from "./RouteNames";

/**
 * 寫在網站裡面的程式變數
 * 有些不該寫死的東西也在這裡ㄛ
 */
const AppConst = {
  GoogleReCaptchaKey: "6Leph_kqAAAAAJiFKjfJYjy8f8rYV5cvrbblUfth",
  BaseURL: "https://api.utfg.tw/api/",
  ActivitySystemURL: "https://utfg-activity.knotting.cc",
  dealersDenFormId: 14,
  // 嘿對就是你
  eventID: 2,
  eventKey: 'UTFG2026',
  /** 不顯示小亞驗證器 */
  disableAsiaMinorCaptcha: true,
  /** Google登入開關 !isDev()哦 */
  disableGoogleLogin: true,
  /** 名牌名稱長度 */
  registrationBadgeFirstLineTextLength: 15,
  registrationBadgeSecondLineTextLength: 30,
  /**
   * 支援的語系, 因為i18n.languages沒有如期運作...
   */
  supportedLanguages: [
    { name: 'zh_Hant', displayName: '繁體中文' },
    { name: 'ja', displayName: '日本語' },
    { name: 'en', displayName: 'English' },
  ],
  /** 取得訂單無效的時間 （松：設定為createdAt + 1小時） */
  getOrderExpireTime: (time: number) => dayjs(time).add(1, 'hour'),

  /** 開發階段的API伺服器 */
  devAPIBase: '/api/',

  /** 給agGrid用的 */
  agGridDefaultColDef: {
    sortable: true,
    filter: true,
    floatingFilter: true,
    resizable: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
};

export default AppConst;

export interface IFunction {
  name: string;
  path?: string;
  permission?: Array<string>;
  children?: Array<IFunction>;
  translate?: { ns: string, key: string }
}

/** 訂房候補表單 id（與選單連結 `event/?id=` 一致） */
export const hotelWaitlistFormId = "13";

export const FrontendFunctions: Array<IFunction> = [
  { name: '總覽', path: '', translate: { ns: 'common', key: 'fields.dashboard.dashboardTitle' } },
  { name: '報名', path: RouteNames.Dashboard_Register, translate: { ns: 'registration', key: 'serviceName' } },
  { name: '訂房', path: RouteNames.Dashboard_Hotel, translate: { ns: 'hotel', key: 'serviceName' } },
  { name: '訂房候補', path: `event/?id=${hotelWaitlistFormId}`, translate: { ns: 'hotel', key: 'hotelWaitlist.title' } },
  { name: '活動', path: 'event', translate: { ns: 'form', key: 'serviceName' } },
  // { name: '獸裝', path: RouteNames.Dashboard_Fursuiter, translate: { ns: 'fursuiter', key: 'serviceName' } },
  // { name: '集點', path: RouteNames.Dashboard_Point, translate: { ns: 'point', key: 'serviceName' } },
  { name: '環球狂歡之夜', path: RouteNames.Dashboard_AfterParty, translate: { ns: 'registration', key: 'fields.afterPartyTicket.serviceName' } },
  // { name: '活動系統 (選擇學院)', path: RouteNames.Dashboard_ActivityRedirect, translate: { ns: 'common', key: 'fields.2025.title' } },
  { name: '帳戶', path: RouteNames.Dashboard_Account, translate: { ns: 'user', key: 'fields.submenu.Account' } },
  
]

export const VolunteerFunctions: Array<IFunction> = [
  { name: "打卡紀錄", path: RouteNames.Volunteer_Punches },
  { name: "補打卡申請", path: RouteNames.Volunteer_MakeUps },
  { name: "志工Token", path: RouteNames.Volunteer_PointToken },
]

export const BackendFunctions: Array<IFunction> = [
  { name: "總覽", path: RouteNames.Backend_Index, permission: ['management.overview'] },
  {
    name: "活動",
    children: [
      { name: "空間", path: RouteNames.Backend_ActivityArea, permission: ['activity.area'] },
      { name: "主題活動", path: RouteNames.Backend_ActivityActivities, permission: ['activity.activity'] },
      { name: "任務", path: RouteNames.Backend_ActivityTask, permission: ['task.task'] },
      { name: "參與紀錄", path: RouteNames.Backend_ActivityParticipationHistory, permission: ['activity.participationHistory'] },
      { name: "活動計數", path: RouteNames.Backend_ActivityStatus, permission: ['activity.activityStatus'] },
    ],
  },
  {
    name: "排班與出勤",
    children: [
      { name: "打卡紀錄", path: RouteNames.Backend_PunchPunches, permission: ['punch.punch'] },
      { name: "補考勤紀錄", path: RouteNames.Backend_PunchMakeups, permission: ['punch.makeUp'] },
      { name: "排班表", path: RouteNames.Backend_PunchSchedules, permission: ['punch.schedule'] },
    ]
  },
  {
    name: "服務台",
    children: [
      { name: "點數查詢與兌換", path: RouteNames.Backend_FrontDeskPoint, permission: ['point.frontdesk.userPoint'] },
      { name: "任務確認", path: RouteNames.Backend_ActivityTaskReport, permission: ['task.taskReport'] },
      { name: "主題活動入場確認", path: RouteNames.Backend_FrontDeskActivityCheckIn, permission: ['activity.activityCheckin'] },
      { name: "上下班打卡", path: RouteNames.Backend_FrontDeskPunchInOut, permission: ['punch.frontdesk.punch'] },
      { name: "領證 與 現場報名", path: RouteNames.Backend_FrontDeskCheckIn, permission: ['registration.frontdesk'] },
      { name: "領取紀念品", path: RouteNames.Backend_FrontDeskSouvenir, permission: ['registration.frontdesk'] },
    ],
  },
  {
    name: "名牌相關",
    children: [
      { name: "讀卡機", path: RouteNames.Backend_BadgeReader, permission: ['badge.badgeReader'] },
      { name: "卡片註冊", path: RouteNames.Backend_CardRegistration, permission: ['badge.cardRegistration'] },
    ],
  },
  { name: "使用者", path: RouteNames.Backend_Users, permission: ['user.user', 'user.user.sensitive'] },
  { name: "群組", path: RouteNames.Backend_Groups, permission: ['user.group'] },
  {
    name: "報名",
    children: [
      {
        name: "報名清單",
        path: RouteNames.Backend_Registrations,
        permission: ['registration.registration', 'registration.registration.sensitive']
      },
      { name: "現場報名", path: RouteNames.Backend_RegistrationsOnsite, permission: ['registration.registrationOnsite'] },
      { name: "等級升級清單", path: RouteNames.Backend_RegistrationUpgrades, permission: ['registration.registrationUpgrade'] },
      { name: "報名等級", path: RouteNames.Backend_Levels, permission: ['registration.level'] },
      { name: "特殊報名Token", path: RouteNames.Backend_RegistrationToken, permission: ['registration.registrationToken'] },
      { name: "After Party 報名", path: RouteNames.Backend_AfterPartyTickets, permission: ['registration.afterParty'] },
    ],
  },
  {
    name: '集點',
    children: [
      { name: '使用者點數', path: RouteNames.Backend_UserPoints, translate: { ns: 'point', key: 'serviceName' } },
      { name: '獎品', path: RouteNames.Backend_Rewards, },
      { name: '義工用加點Token', path: RouteNames.Backend_PointToken, },
      { name: '點數變更歷史', path: RouteNames.Backend_PointHistory, }
    ],
    translate: { ns: 'point', key: 'serviceName' }
  },
  {
    name: "訂單",
    children: [
      { name: "折扣代碼", path: RouteNames.Backend_Coupon, permission: ['payment.coupon'] },
      { name: "訂單查詢", path: RouteNames.Backend_Order, permission: ['payment.order'] },
      { name: "付款設定", path: RouteNames.Backend_PaymentConfig, permission: ['payment.config'] },
    ],
  },
  {
    name: "飯店",
    children: [
      { name: "飯店列表", path: RouteNames.Backend_Hotel, permission: ['hotel.hotel'] },
      { name: "房型列表", path: RouteNames.Backend_Room, permission: ['hotel.room'] },
      { name: "房型組合列表", path: RouteNames.Backend_RoomType, permission: ['hotel.room'] },
      { name: "訂房紀錄", path: RouteNames.Backend_Reservation, permission: ['hotel.reservation'] },
    ],
  },

  { name: "活動表單", path: RouteNames.Backend_FormsBuilder, permission: ['form.all'] },

  {
    name: "毛毛相關",
    children: [
      { name: "毛毛列表", path: RouteNames.Backend_FursuitFursuiters, permission: ['fursuiter.fursuit'] },
      { name: "毛毛更衣室", path: RouteNames.Backend_FursuitChangeRoom, permission: ['fursuiter.changeRoom'] },
      { name: "毛毛標籤", path: RouteNames.Backend_FursuitTags, permission: ['fursuiter.tag'] },
    ]
  },
  {
    name: "黑名單",
    children: [
      { name: "信箱黑名單", path: RouteNames.Backend_EmailBlacklist, permission: ['user.blacklist.email'] },
      { name: "電話黑名單", path: RouteNames.Backend_PhoneBlacklist, permission: ['user.blacklist.phone'] },
    ],
  },

  {
    name: '設定',
    children: [
      { name: "問題列表", path: RouteNames.Backend_Quiz, permission: ['config.quiz'] },
      { name: "所有設定(Config)", path: RouteNames.Backend_Config, permission: ['config.config'] },
    ]
  },
  {
    name: '2023舊',
    children: [
      {
        name: "抽獎",
        children: [
          { name: "獎品", path: RouteNames.Backend_LotteryItem, permission: ['management.superadmin'] },
          { name: "抽獎結果", path: RouteNames.Backend_LotteryResult, permission: ['management.superadmin'] },
        ],
      },
      // { name: "獸之船", path: RouteNames.Backend_Boat, permission: ['boat.boat'] },
    ]
  },
  {
    name: "實驗性功能",
    children: [
      { name: "元件測試區", path: RouteNames.Backend_Experiment, permission: ['management.superadmin'] },
      { name: "RFID Test", path: RouteNames.Backend_RFID, permission: ['management.superadmin'] },
    ],
  },
];
